module.exports = __webpack_public_path__ + "static/media/filter.44a01139.svg";